import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { Regimen, User } from '@cureskin/api-client/src/server-api';
import { extractRegimenProducts } from 'client/helper/regimen-helper';
import { planName, selectedPlanAndVariantIdMap, RegimenService } from '@services/regimen-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { getPlanInfoConfig, planInfoItemId } from '@shared/choose-plan-info/choose-plan-info.constants';
import { ApiClientConstant } from '@cureskin/api-client/src/constant/api-client.constant';

@Component({
  selector: 'app-regimen-details',
  imports: [CommonModule, CsIconModule],
  templateUrl: './regimen-details.component.html',
})
export class RegimenDetailsComponent {
  regimen: InputSignal<Regimen> = input.required<Regimen>();
  user: InputSignal<User> = input.required<User>();

  private readonly regimenService = inject(RegimenService);
  private readonly experimentService = inject(ExperimentService);

  readonly planInfoItemId = planInfoItemId;

  patientName: Signal<string> = computed(() => {
    const name = this.user()?.get('PatientName');
    return name?.split(' ')[0] || '';
  });

  patientAge: Signal<string> = computed(() => {
    return this.user()?.get('Age') || '';
  });

  displayConcernName: Signal<string> = computed(() => {
    return (this.regimen() as any)?.displayConcern?.name || '';
  });

  backgroundColor: Signal<string> = computed(() => {
    const regimen = this.regimen();
    const variantId = this.regimenService.getSelectedVariantIdFromRegimen(regimen);
    return this.regimenService.getBackgroungColourBasedOnVariantId(variantId || '');
  });

  regimenCoverImage: Signal<string> = computed(() => {
    return this.regimen()?.regimenCoverImage || '';
  });

  regimenProductsLength: Signal<number> = computed(() => {
    return extractRegimenProducts(this.regimen() || {})?.length || 0;
  });

  currentPlanInfo = computed(() => {
    const regimen = this.regimen();
    const selectedVariantId = regimen?.selectedVariantId || (regimen as any)?.variantId;

    const currentPlan = Object.values(planName).find(
      (plan) => selectedPlanAndVariantIdMap[plan] === selectedVariantId
    );

    const planInfoConfig = getPlanInfoConfig([], this.experimentService.videoCallExperiment);
    return planInfoConfig[currentPlan || planName.advance];
  });

  isFaceRegimen: Signal<boolean> = computed(() => {
    const regimen = this.regimen();
    return regimen?.class === ApiClientConstant.Regimen.Class.FACE;
  });
}
